<form [formGroup]="formName">
    <textarea rows="5" cols="30" [maxLength]="maxLength" pInputTextarea [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" class="w-full" [placeholder]="placeholder" pattern="^\S.*\S$|^\S$"></textarea>
    @if (formName.controls[controlName]?.errors && (formName.controls[controlName]?.dirty ||
    formName.controls[controlName]?.touched)) {
    <div class="form-errors">
        <div [hidden]="!formName.controls[controlName]?.errors?.pattern" class="text-red-500" translate>
            error_leading_trailing_white_spaces
        </div>
    </div>
    }
</form>